import React, { useState } from "react";
import * as FiIcons from "react-icons/fi";

import { useClient } from "../context/ClientContext";
import SafeIcon from "../common/SafeIcon";
import SignOutButton from "../components/common/SignOutButton";

const {
  FiAlertCircle,
  FiHome,
  FiLoader,
  FiRefreshCw,
} = FiIcons;

export default function NoWorkspace() {
  const {
    user,
    refreshWorkspaces,
    workspaceError,
  } = useClient();

  const [refreshing, setRefreshing] = useState(false);
  const [error, setError] = useState("");

  const handleRefresh = async () => {
    if (refreshing) return;

    setRefreshing(true);
    setError("");

    try {
      const result = await refreshWorkspaces();

      if (!result?.success) {
        setError(
          result?.error ||
            "Unable to refresh your workspaces."
        );
      }
    } catch (err) {
      setError(
        err?.message ||
          "Unable to refresh your workspaces."
      );
    } finally {
      setRefreshing(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4 py-10">
      <div className="w-full max-w-lg rounded-3xl border border-slate-200 bg-white p-8 shadow-sm">
        <div className="mb-6 flex h-14 w-14 items-center justify-center rounded-2xl bg-amber-50 text-amber-700">
          <SafeIcon
            icon={workspaceError || error ? FiAlertCircle : FiHome}
            className="text-2xl"
          />
        </div>

        <h1 className="text-2xl font-black text-slate-900">
          Workspace Access
        </h1>

        <p className="mt-4 text-sm leading-7 text-slate-600">
          You&apos;re signed in as{" "}
          <strong>{user?.email}</strong>, but no authorized organization
          workspace is currently available.
        </p>

        <p className="mt-3 text-sm leading-7 text-slate-600">
          If you&apos;ve received an invitation, reopen its link and accept it
          using this account. If your membership was recently updated, refresh
          your workspaces.
        </p>

        {(error || workspaceError) && (
          <div
            role="alert"
            className="mt-5 rounded-xl bg-red-50 p-4 text-sm text-red-700"
          >
            {error || workspaceError}
          </div>
        )}

        <div className="mt-7 space-y-3">
          <button
            type="button"
            disabled={refreshing}
            onClick={handleRefresh}
            className="flex w-full items-center justify-center gap-2 rounded-xl bg-emerald-600 px-4 py-3 text-sm font-bold text-white hover:bg-emerald-700 disabled:opacity-50"
          >
            <SafeIcon
              icon={refreshing ? FiLoader : FiRefreshCw}
              className={refreshing ? "animate-spin" : ""}
            />

            {refreshing ? "Refreshing..." : "Refresh Workspaces"}
          </button>

          <SignOutButton />
        </div>
      </div>
    </div>
  );
}